module.exports = __webpack_public_path__ + "img/thumbnail_DiamondbackTerrapin_u_normal.883ad4e3.png";